import { useState, useEffect } from 'react'
import { Box, Typography, Avatar, Icon } from '@mui/material'
import defaultAvatar from 'assets/images/default_avatar.png'

const TalentCalendarEvent = ({ data, handleClickDiv, handleClickMore }) => {
  const [interviewSlot, setInterviewSlot] = useState([])

  const currentTime = new Date()

  // date-time object for 1 interview only in event box
  const dateTimeObject = new Date(`${interviewSlot[0]?.end_date}T${interviewSlot[0]?.end_time}`)

  const checkIsPast = (date) => {
    return currentTime > date
  }

  useEffect(() => {
    setInterviewSlot(data)
  }, [data])

  return (
    <Box my={0.5}>
      {interviewSlot?.length > 1 ? (
        <>
          {interviewSlot.slice(0, 2).map((item, index) => {
            const candidateData = item?.relations?.candidateable?.relations?.candidateable

            // date-time object for multiple interviews in event box
            const dateTimeString = `${item?.end_date}T${item?.end_time}`
            const endDateTimeObject = new Date(dateTimeString)

            return (
              <EventBox
                key={index}
                text={`IV: ${candidateData?.name}`}
                useAvatar
                avatarSrc={candidateData?.profile_image_url}
                handleClickDiv={handleClickDiv}
                isPast={checkIsPast(endDateTimeObject)}
                status={item?.status}
              />
            )
          })}
          {interviewSlot.length - 2 > 0 ? (
            <Typography
              onClick={handleClickDiv}
              variant="subtitle2"
              sx={{
                color: 'light-gray-text.main',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >{`${interviewSlot.length - 2} more`}</Typography>
          ) : null}
        </>
      ) : interviewSlot?.length === 1 ? (
        <EventBox
          text={`IV: ${interviewSlot[0]?.relations?.candidateable?.relations?.candidateable?.name}`}
          useAvatar
          avatarSrc={
            interviewSlot[0]?.relations?.candidateable?.relations?.candidateable?.profile_image_url
          }
          handleClickDiv={handleClickDiv}
          isPast={checkIsPast(dateTimeObject)}
          status={interviewSlot[0]?.status}
        />
      ) : null}
    </Box>
  )
}

export default TalentCalendarEvent

const EventBox = ({ text, useAvatar, avatarSrc, handleClickDiv, isPast, status }) => {
  const handleClick = () => {
    handleClickDiv()
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        backgroundColor: 'gray-background.main',
        opacity: isPast && status === 'scheduled' ? 'null' : isPast ? 0.35 : null,
        width: 1,
        height: '25px',
        display: 'flex',
        alignItems: 'center',
        p: 0.75,
        gap: 1,
        my: 0.5,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#f1f3f4',
        },
      }}
    >
      {useAvatar && status === 'scheduled' && isPast ? (
        <Icon sx={{ fontSize: 20, color: 'warning.main' }}>error</Icon>
      ) : (
        <Avatar
          alt="profile"
          sx={{ width: 20, height: 20, bgcolor: 'alternate.main' }}
          src={avatarSrc || defaultAvatar}
        />
      )}

      <Typography
        sx={{ textDecoration: status === 'cancelled' ? 'line-through' : null }}
        noWrap
        variant="caption"
      >
        {text}
      </Typography>
    </Box>
  )
}
